import { useTranslation } from 'react-i18next';

export default function AboutStory() {
  const { t } = useTranslation('about');

  const milestones = [
    { year: '2018', label: t('storyYear1'), text: t('storyMilestone1') },
    { year: '2020', label: t('storyYear2'), text: t('storyMilestone2') },
    { year: '2023', label: t('storyYear3'), text: t('storyMilestone3') },
    { year: '2025', label: t('storyYear4'), text: t('storyMilestone4') },
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block text-xs md:text-sm font-semibold text-amber-600 uppercase tracking-widest mb-4">
              {t('storyLabel')}
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              {t('storyTitle')}
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-4">
              {t('storyDescription')}
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              {t('storyDescription2')}
            </p>
          </div>
          <div className="order-1 lg:order-2">
            <div className="relative pl-8 md:pl-12">
              <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-amber-200" />
              {milestones.map((m, i) => (
                <div key={i} className="relative mb-8 md:mb-10 last:mb-0">
                  <div className="absolute -left-8 md:-left-12 top-1 w-4 h-4 md:w-5 md:h-5 bg-amber-600 rounded-full border-4 border-white shadow-sm" />
                  <div className="bg-amber-50 rounded-xl p-5 md:p-6">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-2xl md:text-3xl font-bold text-amber-700">
                        {m.year}
                      </span>
                      <span className="text-sm font-semibold text-amber-600 uppercase">
                        {m.label}
                      </span>
                    </div>
                    <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                      {m.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}